const GET_POSTING_CONTACT_DATA = 'contactos-permisos/contact-data/GET_POSTING_CONTACT_DATA';
const GET_POSTING_CONTACT_DATA_COMPLETED = 'contactos-permisos/contact-data/GET_POSTING_CONTACT_DATA_COMPLETED';
const GET_POSTING_CONTACT_DATA_FAILED = 'contactos-permisos/contact-data/GET_POSTING_CONTACT_DATA_FAILED';
const UPDATE_USER_RESPONSIBLE_FOR_POSTING = 'contactos-permisos/contact-data/UPDATE_USER_RESPONSIBLE_FOR_POSTING';
const UPDATE_USER_RESPONSIBLE_FOR_POSTING_COMPLETED =
  'contactos-permisos/contact-data/UPDATE_USER_RESPONSIBLE_FOR_POSTING_COMPLETED';
const UPDATE_USER_RESPONSIBLE_FOR_POSTING_FAILED =
  'contactos-permisos/contact-data/UPDATE_USER_RESPONSIBLE_FOR_POSTING_FAILED';

export {
  GET_POSTING_CONTACT_DATA,
  GET_POSTING_CONTACT_DATA_COMPLETED,
  GET_POSTING_CONTACT_DATA_FAILED,
  UPDATE_USER_RESPONSIBLE_FOR_POSTING,
  UPDATE_USER_RESPONSIBLE_FOR_POSTING_COMPLETED,
  UPDATE_USER_RESPONSIBLE_FOR_POSTING_FAILED
};
